import { router } from '@inertiajs/vue3'

export function logout() {
  router.post(route('logout'))
}
